export interface IMySettings_Folder {
  email: boolean;
  folderItemId: number;
  title: string;
}

export interface IMySettings_Topics {
  email: boolean;
  name: string;
  topicId: number;
  website: boolean;
}


export interface IMySettingsRequest {
  emailFolderItemIds: number[];
  emailTopicIds: number[];
  websiteTopicIds: number[];
}

export interface IMySettings {
  folderSettings: IMySettings_Folder[];
  topicSettings: IMySettings_Topics[];
}

export enum E_MANAGE_FIELDS {
  email = 'email',
  website = 'website',
}
